/*@flow*/

function extend(destination, source) {
  return { ...destination, ...source };
}

let eventMatchers = {
  HTMLEvents: /^(?:load|unload|abort|error|select|change|submit|reset|focus|blur|resize|scroll)$/,
  MouseEvents: /^(?:click|dblclick|mouse(?:down|up|over|move|out))$/,
};
let defaultOptions = {
  pointerX: 0,
  pointerY: 0,
  button: 0,
  ctrlKey: false,
  altKey: false,
  shiftKey: false,
  metaKey: false,
  bubbles: true,
  cancelable: true,
};

export default (element: HTMLElement, eventName: string, opts: any = {}): HTMLElement => {
  let options = extend(defaultOptions, opts || {});
  let oEvent,
    eventType = null;

  Object.keys(eventMatchers).forEach((name) => {
    if (eventMatchers[name].test(eventName)) {
      eventType = name;
    }
  });

  if (!eventType) {
    throw new SyntaxError(
      'Only HTMLEvents and MouseEvents interfaces are supported'
    );
  }

  if (document.createEvent) {
    oEvent = document.createEvent(eventType);
    oEvent.initEvent(eventName, options.bubbles, options.cancelable);
    element.dispatchEvent(oEvent);
  } else {
    options.clientX = options.pointerX;
    options.clientY = options.pointerY;
    // $FlowFixMe[prop-missing]
    let evt = document.createEventObject();
    oEvent = extend(evt, options);
    // $FlowFixMe[prop-missing]
    element.fireEvent('on' + eventName, oEvent);
  }
  return element;
};
